import * as angular from 'angular';
import { Decimal } from 'decimal.js';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpNoDecimalValidator
     * @memberof app
     *
     * @restrict A
     *
     * @description
     * Ain't Nobody Got Time for That
     *
     * @attr {PkpUseOriginals} pkpUseOriginals
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .directive('pkpNoDecimalValidator', pkpNoDecimalValidator);

    function pkpNoDecimalValidator(fieldKeyService) {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            var fieldKey = fieldKeyService.initialize(attr.pkpUseOriginals);

            ngModelCtrl.$validators.pkpNoDecimalValidator = function (
                modelValue
            ) {
                if (
                    !modelValue ||
                    !modelValue[fieldKey.valueKey] ||
                    ngModelCtrl.$isEmpty(modelValue[fieldKey.valueKey].value)
                ) {
                    return true;
                }

                try {
                    if (
                        new Decimal(
                            modelValue[fieldKey.valueKey].value
                        ).decimalPlaces() > 0
                    ) {
                        return false;
                    }
                } catch (e) {
                    return false;
                }

                return true;
            };

            attr.$observe('pkpNoDecimalValidator', function () {
                ngModelCtrl.$validate();
            });
        }
    }
})();
